module.exports = require("@bechtel/client-assets/dist/images/bechtel-logo.svg");